<div [class.sb-profile-button-wrapper]="isMobile">
    <div
        class="sb-avatar-button-container"
        data-clarity-mask="true">
        <lib-profile-image
            [size]="avatarSize"
            [displayItem]="displayItem"
            [hasImageToShow]="hasImage"
            [imageURL]="imageURL ?? ''"></lib-profile-image>
        <div>
            <lib-button
                [kind]="kind"
                [size]="ButtonSize.Large"
                [urlLink]="profileURL ?? ''"
                [qaTag]="qaTag"
                [truncate]="truncate"
                (clicked)="ButtonClicked()">
                <ng-container label>{{ name }}</ng-container>
            </lib-button>
            @if (!isMobile) {
                <div class="sb-profile-button-status">
                    <ng-container *ngTemplateOutlet="statusTemplate"></ng-container>
                </div>
            }
        </div>
    </div>

    @if (isMobile) {
        <ng-container *ngTemplateOutlet="statusTemplate"></ng-container>
    }
</div>

<ng-template #statusTemplate>
    <ng-content select="[status]"></ng-content>
</ng-template>
